module.exports = __webpack_public_path__ + "static/media/Свидетельство о внесении сведений в государственный реестр микрофинансовых организаций.90baa4ef.jpg";